import React from 'react';
import { useField } from 'formik';
import Form from 'react-bootstrap/Form';

import styles from './lifestage.module.scss';
import { Function } from 'lodash';

export enum InputAlign {
  LEFT = 'left',
  CENTER = 'center',
}

interface BreedProps {
  // name: string;
  inputAlign?: InputAlign;
  // nextStep: any
}
const lifestages = [
  { label1: 'Puppy', label2: '0-1 years', value: 'puppy' },
  { label1: 'Adult', label2: '1-7 years', value: 'adult' },
  { label1: 'Senior', label2: '+8 years', value: 'senior' },
];
const LifeStage: React.FC<BreedProps> = props => {
  const [field, meta, helpers] = useField('lifestage');
  const { setValue, setTouched } = helpers;

  const setLifestage = (value: string) => {
    setValue(value);
    setTouched(true);
    // if (props.name && value) {
    //   setTimeout(() => {props.nextStep(prev => prev + 1)}, 1000)
    // }

  };
  // };
  const value = meta?.value || '';
  return (
    <Form.Group controlId="formBreed" className={'align-col-cen'}>
      <Form.Label className='form-label'>
        What is your dog's lifestage?
      </Form.Label>
      <div className={styles.lifestageContainer}>
        {lifestages.map((it, index) => (
          <label className={styles.stageItem} key={'lifestage' + index}>
            <input
              type="radio"
              value={it.value}
              name="lifestages"
              checked={value == it.value}
              onChange={e => setLifestage(e.target.value)}
            />
            <div className="box">
              <div className="content">
                <span className="primary-text">{it.label1}</span>
                <span className="secondary-text">{it.label2}</span>
              </div>
            </div>
          </label>
        ))}
      </div>
    </Form.Group>
  );
};

export default LifeStage;
